export const ORGANIZATION_MFO_LIST = '/:orgType(zaimy)/rating-mfo/:service?/:location?';
export const ORGANIZATION_LIST =
  '/:orgType/rating/:customerType(dlya-predprinimatelej|dlya-chastnyh-lic)?/:service?/:location?';
export const PRODUCT_LIST =
  '/:orgType/rating-productov/:customerType(dlya-predprinimatelej|dlya-chastnyh-lic)?/:service/:location?';

export const OLD_LIST = '/:orgType/rating/klientskij/:any?/:any2?';
export const OLD_BANKI_BY_CATEGORY =
  '/:orgType(banki)/rating/klientskij/:customerType(dlya-predprinimatelej|dlya-chastnyh-lic)/:any?/:any2?';
export const OLD_UNKNOWN_ROUTE = '/:orgType(banki)/rating/finansovij';

export const REDIRECTS_301: Array<[string, string]> = [
  ['/banki/rating/kredity-fizicheskikh-lic', '/banki/rating/dlya-chastnyh-lic/kredity'],
  ['/banki/rating/depozity-fizicheskikh-lic', '/banki/rating/dlya-chastnyh-lic/vklady'],
  [OLD_UNKNOWN_ROUTE, ORGANIZATION_LIST],
  [OLD_BANKI_BY_CATEGORY, ORGANIZATION_LIST],
  [OLD_LIST, ORGANIZATION_LIST],
];
